<template>
	<div class="warehouse-exit">
		<div class="tablebox">
			<div class="filterdiv filterty" ref="filter">
				<el-form :inline="true" :model="formfilter" class="demo-form-inline" size="small" label-width="0"
					v-if="filtershow">
					<el-form-item>
						<el-select v-model="formfilter.state" placeholder="全部状态" clearable>
							<el-option label="全部状态" value=""></el-option>
							<el-option :label="v.name" :value="v.id" v-for="v in stateList" :key="v.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="onfilter">查询</el-button>
						<el-button @click="onreset">重置</el-button>
					</el-form-item>
				</el-form>
			</div>
			<div class="zk" @click="filtershow = !filtershow">
				<span>{{ filtershow ? '收起' : '展开' }}</span>
			</div>
			<div class="tablediv" ref="tablediv">
				<el-table :data="list" style="width: 100%" border height="100%">
					<el-table-column prop="apply_no" label="申请单号" align="center" header-align="center" min-width="180px"></el-table-column>
					<el-table-column prop="seller_username" label="卖家" align="center" header-align="center" min-width="90px"></el-table-column>
					<el-table-column prop="state_str" label="状态" align="center" header-align="center" width="90px">
						<template slot-scope="scope">
							<span :class="'state-' + scope.row.state">{{ scope.row.state_str }}</span>
						</template>
					</el-table-column>
					<el-table-column prop="reason_str" label="原因" align="center" header-align="center" min-width="110px"></el-table-column>
					<el-table-column prop="total_quantity" label="件数" align="center" header-align="center" width="70px"></el-table-column>
					<el-table-column label="收货信息" align="center" header-align="center" min-width="180px">
						<template slot-scope="scope">
							<div>{{ scope.row.receiver_name }} {{ scope.row.receiver_mobile }}</div>
							<div class="sub">{{ scope.row.receiver_address }}</div>
						</template>
					</el-table-column>
					<el-table-column label="物流/费用" align="center" header-align="center" min-width="180px">
						<template slot-scope="scope">
							<div v-if="scope.row.state == 2">拒绝：{{ scope.row.audit_remark || '-' }}</div>
							<div v-if="scope.row.shipping_name">{{ scope.row.shipping_name }} {{ scope.row.shipping_tracking_no }}</div>
							<div v-if="scope.row.shipping_time_str">发货：{{ scope.row.shipping_time_str }}</div>
							<div v-if="scope.row.state >= 3">{{ feeText(scope.row) }}</div>
							<div v-if="scope.row.compensate_state_str">结算：{{ scope.row.compensate_state_str }}</div>
						</template>
					</el-table-column>
					<el-table-column prop="create_time_str" label="申请时间" align="center" header-align="center" width="160px"></el-table-column>
					<el-table-column label="操作" fixed="right" align="center" header-align="center" width="150px">
						<template slot-scope="scope">
							<div class="operation_i">
								<span @click="openDetail(scope.row)">详情</span>
								<span v-if="scope.row.state == 0" @click="openAudit(scope.row)">审核</span>
								<span v-if="scope.row.state == 1" @click="openShip(scope.row)">发货</span>
								<span v-if="scope.row.state == 3" @click="openShip(scope.row, true)">修改物流/费用</span>
							</div>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="pagediv">
				<el-pagination background layout="prev, pager, next, sizes, total" :page-sizes="[20, 30, 50, 100, 200]"
					:current-page.sync="page" :page-size="pageSize" :total="total" v-if="total > 0"
					@current-change="handleCurrentChange" @size-change="handleSizeChange">
				</el-pagination>
			</div>
		</div>

		<el-dialog :title="'取回详情 · ' + (currentDetail.apply_no || '')" :visible.sync="detailShow" width="720px"
			:before-close="closeDetail">
			<div class="detail-box" v-if="detailShow">
				<div class="detail-meta">
					<div><span>卖家</span>{{ currentDetail.seller_username || '-' }}</div>
					<div><span>状态</span>{{ currentDetail.state_str || '-' }}</div>
					<div><span>原因</span>{{ currentDetail.reason_str || '-' }}</div>
					<div><span>件数</span>{{ currentDetail.total_quantity || 0 }}</div>
					<div><span>收货人</span>{{ currentDetail.receiver_name }} {{ currentDetail.receiver_mobile }}</div>
					<div><span>地址</span>{{ currentDetail.receiver_address }}</div>
				</div>
				<div class="detail-extra" v-if="currentDetail.state == 2">拒绝：{{ currentDetail.audit_remark || '-' }}</div>
				<div class="detail-extra" v-if="currentDetail.shipping_name">
					物流：{{ currentDetail.shipping_name }} {{ currentDetail.shipping_tracking_no }}
				</div>
				<div class="detail-extra" v-if="currentDetail.state >= 3">{{ feeText(currentDetail) }}</div>
				<div class="detail-extra" v-if="currentDetail.shipping_time_str">发货：{{ currentDetail.shipping_time_str }}</div>
				<div class="detail-extra" v-if="currentDetail.confirm_time_str">确认：{{ currentDetail.confirm_time_str }}</div>
				<div class="detail-extra" v-if="currentDetail.compensate_state_str">费用结算：{{ currentDetail.compensate_state_str }}</div>
				<el-table :data="currentDetail.items || []" border size="mini" style="width: 100%">
					<el-table-column prop="style_number" label="款号" min-width="120" align="center"></el-table-column>
					<el-table-column prop="size" label="尺码" width="70" align="center"></el-table-column>
					<el-table-column prop="quantity" label="申请件数" width="90" align="center"></el-table-column>
					<el-table-column label="供货价" width="90" align="center">
						<template slot-scope="scope">¥{{ fenToYuan(scope.row.unit_cost) }}</template>
					</el-table-column>
				</el-table>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button v-if="currentDetail.state == 0" type="primary" @click="openAuditFromDetail">审核</el-button>
				<el-button v-if="currentDetail.state == 1" type="primary" @click="openShipFromDetail">发货</el-button>
				<el-button v-if="currentDetail.state == 3" type="primary" @click="openShipFromDetail">修改物流/费用</el-button>
				<el-button @click="closeDetail">关闭</el-button>
			</div>
		</el-dialog>

		<el-dialog :title="'审核取回 · ' + (currentAudit.apply_no || '')" :visible.sync="auditShow" width="640px"
			:before-close="closeAudit">
			<div class="detail-box" v-if="auditShow">
				<div class="detail-meta">
					<div><span>卖家</span>{{ currentAudit.seller_username || '-' }}</div>
					<div><span>原因</span>{{ currentAudit.reason_str || '-' }}</div>
					<div><span>件数</span>{{ currentAudit.total_quantity || 0 }}</div>
				</div>
				<el-table :data="currentAudit.items || []" border size="mini" style="width: 100%" max-height="220">
					<el-table-column prop="style_number" label="款号" min-width="110" align="center"></el-table-column>
					<el-table-column prop="size" label="尺码" width="70" align="center"></el-table-column>
					<el-table-column prop="quantity" label="件数" width="70" align="center"></el-table-column>
				</el-table>
				<el-form class="audit-form" label-width="80px">
					<el-form-item label="备注">
						<el-input type="textarea" v-model="auditRemark" :rows="2" placeholder="拒绝时必填"></el-input>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="closeAudit">取消</el-button>
				<el-button type="danger" :loading="auditing" @click="onAudit(2)">拒绝</el-button>
				<el-button type="primary" :loading="auditing" @click="onAudit(1)">通过</el-button>
			</div>
		</el-dialog>

		<el-dialog :title="shipEdit ? '修改物流/费用' : '取回发货'" :visible.sync="shipShow" width="520px" :before-close="closeShip">
			<div class="forms" v-if="shipShow">
				<el-form label-width="110px">
					<el-form-item label="快递公司">
						<el-input v-model="shipForm.shipping_name" placeholder="请输入快递公司"></el-input>
					</el-form-item>
					<el-form-item label="物流单号">
						<el-input v-model="shipForm.shipping_tracking_no" placeholder="请输入物流单号"></el-input>
					</el-form-item>
					<el-form-item label="运费类型">
						<el-radio-group v-model="shipForm.freight_type">
							<el-radio :label="2">寄付</el-radio>
							<el-radio :label="1">到付</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="运费">
						<el-input v-model="shipForm.freight_yuan" placeholder="0.00" :disabled="shipForm.freight_type == 1">
							<template slot="append">元</template>
						</el-input>
					</el-form-item>
					<el-form-item label="操作补偿">
						<el-input v-model="shipForm.compensation_yuan" placeholder="选填，双方自愿">
							<template slot="append">元</template>
						</el-input>
					</el-form-item>
					<div class="form-tip">{{ shipFeeText }}。到付时运费不参与系统划转，强制为 0；余额不足则转线下。</div>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="closeShip">取消</el-button>
				<el-button type="primary" :loading="shipping" @click="onShip">确定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import { fenToYuan, yuanToFen, apiMsg } from './money.js'

	export default {
		name: 'WarehouseExit',
		data() {
			return {
				list: [],
				page: 1,
				pageSize: 20,
				total: 0,
				filtershow: true,
				formfilter: {
					state: ''
				},
				stateList: [
					{ id: 0, name: '待审核' },
					{ id: 1, name: '通过' },
					{ id: 2, name: '拒绝' },
					{ id: 3, name: '已发货' },
					{ id: 4, name: '已完成' }
				],
				detailShow: false,
				currentDetail: {},
				auditShow: false,
				auditing: false,
				currentAudit: {},
				auditRemark: '',
				shipShow: false,
				shipping: false,
				shipEdit: false,
				currentShip: {},
				shipForm: {
					shipping_name: '',
					shipping_tracking_no: '',
					freight_type: 2,
					freight_yuan: '',
					compensation_yuan: ''
				},
				queryOpened: false
			}
		},
		computed: {
			shipFeeText() {
				var type = Number(this.shipForm.freight_type || 2)
				var freight = 0
				var compensation = 0
				if (type === 2 && this.shipForm.freight_yuan !== '') {
					freight = yuanToFen(this.shipForm.freight_yuan)
				}
				if (this.shipForm.compensation_yuan !== '') {
					compensation = yuanToFen(this.shipForm.compensation_yuan)
				}
				if (isNaN(freight) || freight < 0) {
					freight = 0
				}
				if (isNaN(compensation) || compensation < 0) {
					compensation = 0
				}
				var total = freight + compensation
				var parts = type === 1
					? '到付不划转运费 + 补偿 ¥' + fenToYuan(compensation)
					: '运费 ¥' + fenToYuan(freight) + ' + 补偿 ¥' + fenToYuan(compensation)
				return '卖家确认收货后划转 ¥' + fenToYuan(total) + '（' + parts + '）'
			}
		},
		watch: {
			'shipForm.freight_type'(val) {
				if (Number(val) === 1) {
					this.shipForm.freight_yuan = '0.00'
				}
			}
		},
		mounted() {
			if (!this.$route.query.apply_no && (this.$route.query.state === '0' || this.$route.query.state === '1')) {
				this.formfilter.state = Number(this.$route.query.state)
			}
			this.onlist()
			this.resizeObserver = new ResizeObserver(entries => {
				for (let entry of entries) {
					const cr = entry.contentRect
					if (this.$refs.tablediv) {
						this.$refs.tablediv.style.height = 'calc(100% - ' + (Number(cr.height) + 30) + 'px)'
					}
				}
			})
			if (this.$refs.filter) {
				this.resizeObserver.observe(this.$refs.filter)
			}
		},
		beforeDestroy() {
			if (this.resizeObserver) {
				this.resizeObserver.disconnect()
			}
		},
		methods: {
			fenToYuan: fenToYuan,
			feeText(row) {
				var parts = []
				if (Number(row.freight_type) === 1) {
					parts.push('到付')
				} else if (row.freight != null) {
					parts.push('运费 ¥' + this.fenToYuan(row.freight))
				}
				if (Number(row.compensation || 0) > 0) {
					parts.push('补偿 ¥' + this.fenToYuan(row.compensation))
				}
				return parts.join(' · ')
			},
			onfilter() {
				this.page = 1
				this.onlist()
			},
			onreset() {
				this.formfilter.state = ''
				this.page = 1
				this.onlist()
			},
			handleCurrentChange() {
				this.onlist()
			},
			handleSizeChange(val) {
				this.page = 1
				this.pageSize = val
				this.onlist()
			},
			openDetail(row) {
				this.currentDetail = row || {}
				this.detailShow = true
			},
			closeDetail() {
				this.detailShow = false
				this.currentDetail = {}
			},
			openAuditFromDetail() {
				var row = this.currentDetail
				this.closeDetail()
				this.openAudit(row)
			},
			openShipFromDetail() {
				var row = this.currentDetail
				var edit = row.state == 3
				this.closeDetail()
				this.openShip(row, edit)
			},
			openAudit(row) {
				this.currentAudit = row || {}
				this.auditRemark = ''
				this.auditShow = true
			},
			closeAudit() {
				this.auditShow = false
				this.currentAudit = {}
				this.auditRemark = ''
			},
			onAudit(state) {
				if (state == 2 && !String(this.auditRemark || '').trim()) {
					this.$message.warning('拒绝时请填写备注')
					return
				}
				this.auditing = true
				this.$axios.post('api/cloud_warehouse/exit_audit', {
					apply_no: this.currentAudit.apply_no,
					state: state,
					audit_remark: this.auditRemark
				}).then(res => {
					this.auditing = false
					if (res.data.code === 0) {
						this.$message.success(state == 1 ? '已通过取回申请' : '已拒绝取回申请')
						this.closeAudit()
						this.onlist()
					} else {
						this.$message.error(apiMsg(res))
					}
				}).catch(err => {
					this.auditing = false
					console.log(err)
				})
			},
			openShip(row, edit) {
				this.currentShip = row || {}
				this.shipEdit = !!edit
				this.shipForm = {
					shipping_name: row.shipping_name || '',
					shipping_tracking_no: row.shipping_tracking_no || '',
					freight_type: Number(row.freight_type || 2),
					freight_yuan: Number(row.freight_type) === 1 ? '0.00' : this.fenToYuan(row.freight),
					compensation_yuan: row.compensation ? this.fenToYuan(row.compensation) : ''
				}
				this.shipShow = true
			},
			closeShip() {
				this.shipShow = false
				this.currentShip = {}
			},
			onShip() {
				if (!String(this.shipForm.shipping_name || '').trim()) {
					this.$message.warning('请输入快递公司')
					return
				}
				if (!String(this.shipForm.shipping_tracking_no || '').trim()) {
					this.$message.warning('请输入物流单号')
					return
				}
				var freightType = Number(this.shipForm.freight_type || 2)
				var freight = 0
				if (freightType === 2 && this.shipForm.freight_yuan !== '') {
					freight = yuanToFen(this.shipForm.freight_yuan)
					if (isNaN(freight) || freight < 0) {
						this.$message.warning('请输入正确的运费')
						return
					}
				}
				var compensation = 0
				if (this.shipForm.compensation_yuan !== '') {
					compensation = yuanToFen(this.shipForm.compensation_yuan)
					if (isNaN(compensation) || compensation < 0) {
						this.$message.warning('请输入正确的补偿金额')
						return
					}
				}
				this.shipping = true
				this.$axios.post('api/cloud_warehouse/exit_ship', {
					apply_no: this.currentShip.apply_no,
					shipping_name: this.shipForm.shipping_name,
					shipping_tracking_no: this.shipForm.shipping_tracking_no,
					freight_type: freightType,
					freight: freight,
					compensation: compensation
				}).then(res => {
					this.shipping = false
					if (res.data.code === 0) {
						this.$message.success(this.shipEdit ? '物流/费用已更新' : '已发货')
						this.closeShip()
						this.onlist()
					} else {
						this.$message.error(apiMsg(res))
					}
				}).catch(err => {
					this.shipping = false
					console.log(err)
				})
			},
			tryOpenQuery() {
				var no = this.$route.query.apply_no
				if (!no || this.queryOpened) {
					return
				}
				var row = this.list.filter(function(item) {
					return String(item.apply_no) === String(no)
				})[0]
				if (row) {
					this.queryOpened = true
					if (row.state == 0) {
						this.openAudit(row)
					} else if (row.state == 1 || row.state == 3) {
						this.openShip(row, row.state == 3)
					} else {
						this.openDetail(row)
					}
				}
			},
			onlist() {
				var params = {
					page: this.page,
					limit: this.pageSize,
					role: 'buyer'
				}
				if (this.formfilter.state !== '' && this.formfilter.state !== null) {
					params.state = this.formfilter.state
				}
				this.$axios.get('api/cloud_warehouse/exit_list', { params: params }).then(res => {
					if (res.data.code === 0) {
						var data = res.data.data || {}
						this.list = data.list || []
						this.total = data.count || 0
						this.tryOpenQuery()
					} else {
						this.$message.error(apiMsg(res))
					}
				}).catch(err => {
					console.log(err)
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.warehouse-exit {
		height: 100%;
	}

	.tablebox {
		height: 100%;
	}

	.sub {
		color: #909399;
		font-size: 12px;
	}

	.state-0 {
		color: #E6A23C;
	}
	.state-1,
	.state-3 {
		color: #409EFF;
	}
	.state-2 {
		color: #F56C6C;
	}
	.state-4 {
		color: #67C23A;
	}

	.detail-meta {
		display: flex;
		flex-wrap: wrap;
		margin-bottom: 12px;
		div {
			width: 50%;
			line-height: 26px;
			box-sizing: border-box;
			padding-right: 12px;
			span {
				display: inline-block;
				width: 56px;
				color: #909399;
			}
		}
	}

	.detail-extra,
	.audit-form {
		margin: 12px 0 0;
	}

	.form-tip {
		color: #909399;
		font-size: 12px;
		line-height: 20px;
		padding-left: 110px;
	}
</style>



// WEBPACK FOOTER //
// src/components/buyer/warehouse/exit.vue